import { useSelector } from 'react-redux';

import {
  selectBackOfficeDeviceMapPointsState
} from './selectors';

export function useBackOfficeDeviceMapPoints() {
  return useSelector(selectBackOfficeDeviceMapPointsState);
}
